'use client';
import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Drawer, DrawerContent, DrawerTitleHeader } from '@/components/ui/drawer';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
// import { track } from '@/utils/track';
import { Button } from '@/components/ui/button';

interface ModalSecondConfirmProps {
  /** 自定义样式 */
  className?: string;
  /** 关闭弹窗时的回调函数 */
  onClose?: () => void;
  /** 编辑成功时的回调函数 */
  onSuccess?: () => void;
}

// Main Modal Component
const ModalSecondConfirm = NiceModal.create<ModalSecondConfirmProps>(({
  className,
  onClose,
}) => {
  const modal = useModal();
  const tHome = useTranslations('home');
  const closeDialog = () => {
    modal.hide();
    onClose?.();
    modal.resolve({ result: false, code: '' });
  };

  const handleSure = async () => {
    modal.resolve({ result: true });
    closeDialog();
  };

  return (
    <Drawer open={modal.visible} onClose={closeDialog} onOpenChange={(open) => !open && closeDialog()}>
      <DrawerContent className={clsx(
        " bg-surface",
        className
      )}>
        <DrawerTitleHeader title={tHome('currency.switch.title')} showClose />
        <div className='relative flex flex-col items-center px-[12px] pb-[30px]'>
          <div className='text-[15px] font-medium leading-[17px] text-tertiary text-center py-[35px] px-[43px] bg-dark-special rounded-[8px]'>
            {tHome('currency.switch.desc')}
          </div>
          <div className="btn-group w-full flex items-center mt-[30px]">
            <Button variant='cancel' onClick={closeDialog} className='flex-1 large-btn mr-2.5'>
              {tHome('currency.switch.cancelBtn')}
            </Button>
            <Button variant='primary' onClick={handleSure} className='flex-1 large-btn'>
              {tHome('currency.switch.confirmBtn')}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

ModalSecondConfirm.displayName = 'ModalSecondConfirm';

// eslint-disable-next-line react-refresh/only-export-components
export const showModalSecondConfirm: (props: ModalSecondConfirmProps) => Promise<{ result: boolean, code_token: string; }> = (props) => {
  return NiceModal.show(ModalSecondConfirm, props);
};

export default ModalSecondConfirm;
